import React, { FC } from 'react';
import { OfferIcon, SkeletonBodyText } from '../elements';
import UpsellListItem from '../OfferBody/tree/UpsellListItem';
import UpsellOffer from '../OfferBody/tree/UpsellOffer';
import OfferDescriptionAndTitle from '../OfferBody/tree/OfferDescriptionAndTitle';

type SkeletonOfferProps = {
  indexInOffers?: number;
  offerCount: number;
};

const SkeletonOfferTree: FC<SkeletonOfferProps> = ({
  indexInOffers,
  offerCount,
}) => (
  <UpsellListItem>
    <UpsellOffer indexInOffers={indexInOffers} offerCount={offerCount}>
      <OfferDescriptionAndTitle>
        <OfferIcon />
        <div className="w-full md:w-210 md:mt-4">
          <SkeletonBodyText
            containerClassName="my-none mx-15 pb-10 w-11/12"
            contentClassName="rounded-sm"
          />
          <SkeletonBodyText
            containerClassName="my-none mx-15 pb-10 w-9/12"
            contentClassName="rounded-sm"
          />
          <SkeletonBodyText
            containerClassName="md:hidden my-none mx-15 pb-none w-9/12"
            contentClassName="rounded-sm"
          />
        </div>
      </OfferDescriptionAndTitle>
    </UpsellOffer>
  </UpsellListItem>
);

export default SkeletonOfferTree;
